module.exports = __webpack_public_path__ + "img/team-oldenburgoutlaws.4ac3c887.jpg";